'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Input } from '@common/components';
import { FOCUS_RING } from '@common/components/interaction';
import SvgMagnifyingGlass from '@common/icon/SvgMagnifyingGlass';
import { cn } from '@core/utils';
import type { Ref } from 'react';
import type { useRegionFinder } from '../_hooks/useRegionFinder';
import { ALL_TAB_LABEL } from '../_hooks/useRegionFinder';
interface RegionFinderContentProps {
  finder: ReturnType<typeof useRegionFinder>;
  onSelect: (id: string) => void;
  onSelectAll?: () => void;
  inputRef?: Ref<HTMLInputElement>;
  dropdown?: boolean;
}
export const RegionFinderContent = t0 => {
  const $ = _c(56);
  const {
    finder,
    onSelect,
    onSelectAll,
    inputRef,
    dropdown: t1
  } = t0;
  const dropdown = t1 === undefined ? false : t1;
  const {
    searchKeyword,
    selectedParentId,
    provinces,
    rows,
    isPending,
    isError,
    isFetching
  } = finder;
  let t2;
  if ($[0] !== provinces || $[1] !== selectedParentId) {
    t2 = provinces?.find(province => province.homeLoveGovCodeId === selectedParentId)?.value.trim() ?? ALL_TAB_LABEL;
    $[0] = provinces;
    $[1] = selectedParentId;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const selectedLabel = t2;
  const t3 = dropdown ? "px-20 pb-20 pt-16" : "px-20 pb-16";
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <SvgMagnifyingGlass className="size-20 text-Gray-550" />;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  let t6;
  if ($[4] !== finder) {
    t5 = event => finder.handleSearchChange(event.target.value);
    t6 = () => finder.handleSearchChange("");
    $[4] = finder;
    $[5] = t5;
    $[6] = t6;
  } else {
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  if ($[7] !== inputRef || $[8] !== searchKeyword || $[9] !== t5 || $[10] !== t6) {
    t7 = <Input ref={inputRef} type="search" aria-label={"\uC9C0\uC5ED\uBA85 \uAC80\uC0C9"} placeholder={"\uC9C0\uC5ED\uC744 \uCC3E\uC544\uBCF4\uC138\uC694"} value={searchKeyword} leftContent={t4} onChange={t5} onClear={t6} />;
    $[7] = inputRef;
    $[8] = searchKeyword;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t3 || $[13] !== t7) {
    t8 = <div className={t3}>{t7}</div>;
    $[12] = t3;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const t9 = !dropdown && "border-t border-Gray-200";
  let t10;
  if ($[15] !== t9) {
    t10 = cn("flex min-h-0 flex-1", t9);
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  const t11 = dropdown ? "w-160" : "w-130";
  let t12;
  if ($[17] !== t11) {
    t12 = cn("shrink-0 overflow-y-auto bg-Gray-50", t11);
    $[17] = t11;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== dropdown || $[20] !== finder || $[21] !== provinces || $[22] !== selectedParentId) {
    t13 = [{
      homeLoveGovCodeId: null,
      value: ALL_TAB_LABEL
    }, ...(provinces ?? [])].map(t14 => {
      const {
        homeLoveGovCodeId,
        value
      } = t14;
      return <li key={homeLoveGovCodeId ?? ALL_TAB_LABEL}><button type="button" aria-pressed={selectedParentId === homeLoveGovCodeId} className={cn("flex w-full items-center justify-center px-8 text-center font-700 typo-body4", dropdown ? "h-60" : "h-62", FOCUS_RING, selectedParentId === homeLoveGovCodeId ? "bg-O-500 text-Gray-white" : "text-Gray-900")} onClick={() => finder.handleSelectParentId(homeLoveGovCodeId)}><span className="line-clamp-2">{value.trim()}</span></button></li>;
    });
    $[19] = dropdown;
    $[20] = finder;
    $[21] = provinces;
    $[22] = selectedParentId;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t12 || $[25] !== t13) {
    t14 = <ul aria-label={"\uC2DC\uB3C4 \uC120\uD0DD"} className={t12}>{t13}</ul>;
    $[24] = t12;
    $[25] = t13;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== isError || $[28] !== isPending || $[29] !== rows || $[30] !== searchKeyword || $[31] !== selectedLabel) {
    t15 = isError ? "\uC9C0\uC5ED \uC870\uD68C \uC2E4\uD328" : isPending ? "\uC9C0\uC5ED\uC744 \uBD88\uB7EC\uC624\uB294 \uC911\u2026" : `${searchKeyword.trim() ? "\uAC80\uC0C9 \uACB0\uACFC" : selectedLabel} · ${rows.length}개`;
    $[27] = isError;
    $[28] = isPending;
    $[29] = rows;
    $[30] = searchKeyword;
    $[31] = selectedLabel;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== t15) {
    t16 = <p role="status" className="sr-only">{t15}</p>;
    $[33] = t15;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== dropdown || $[36] !== finder || $[37] !== isError || $[38] !== isFetching || $[39] !== isPending || $[40] !== onSelect || $[41] !== onSelectAll || $[42] !== rows || $[43] !== searchKeyword || $[44] !== selectedParentId) {
    t17 = isError ? <div className="flex flex-col items-center gap-12 px-12 py-24 text-center"><p className="text-Gray-600 typo-body4">지역을 불러오지 못했어요.<br />잠시 후 다시 시도해 주세요.</p><Button dimensions="H40" theme="sub-line" disabled={isFetching} onClick={() => void finder.retry()}>다시 시도</Button></div> : <ul key={selectedParentId} aria-label={"\uC9C0\uC5ED \uAC80\uC0C9 \uACB0\uACFC"} aria-busy={isPending} className={cn("min-h-0 flex-1 overflow-y-auto bg-Gray-white", dropdown && "grid auto-rows-min grid-cols-2 content-start")}>{!isPending && rows.length === 0 ? <li className="col-span-full h-92 text-Gray-600 flex-center typo-body4">조회된 지역이 없어요.</li> : [...(onSelectAll && selectedParentId === null && !searchKeyword.trim() ? [{
        key: 0,
        label: "\uC804\uCCB4 \uC9C0\uC5ED",
        shortLabel: "\uC804\uCCB4 \uC9C0\uC5ED",
        id: null
      }] : []), ...rows].map(t18 => {
        const {
          key,
          label,
          shortLabel,
          id
        } = t18;
        return <li key={key} className={cn("border-b border-Gray-200", dropdown && "odd:border-r")}><button type="button" aria-label={label} className={cn("flex w-full items-center px-12 text-left font-600 text-Gray-900 typo-body4", dropdown ? "h-60" : "py-20", FOCUS_RING, "transition-colors duration-150 hover:bg-Gray-50 active:bg-Gray-50 motion-reduce:transition-none")} onClick={() => id === null ? onSelectAll?.() : onSelect(id)}>{dropdown && selectedParentId !== null ? shortLabel : label}</button></li>;
      })}</ul>;
    $[35] = dropdown;
    $[36] = finder;
    $[37] = isError;
    $[38] = isFetching;
    $[39] = isPending;
    $[40] = onSelect;
    $[41] = onSelectAll;
    $[42] = rows;
    $[43] = searchKeyword;
    $[44] = selectedParentId;
    $[45] = t17;
  } else {
    t17 = $[45];
  }
  let t18;
  if ($[46] !== t16 || $[47] !== t17) {
    t18 = <div className="flex min-w-0 flex-1 flex-col bg-Gray-white">{t16}{t17}</div>;
    $[46] = t16;
    $[47] = t17;
    $[48] = t18;
  } else {
    t18 = $[48];
  }
  let t19;
  if ($[49] !== t10 || $[50] !== t14 || $[51] !== t18) {
    t19 = <div className={t10}>{t14}{t18}</div>;
    $[49] = t10;
    $[50] = t14;
    $[51] = t18;
    $[52] = t19;
  } else {
    t19 = $[52];
  }
  let t20;
  if ($[53] !== t19 || $[54] !== t8) {
    t20 = <>{t8}{t19}</>;
    $[53] = t19;
    $[54] = t8;
    $[55] = t20;
  } else {
    t20 = $[55];
  }
  return t20;
};